import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 8.5H3V7.5H13V8.5Z", fill: "#003568" }));
export default SvgMinus;
